module.exports = __webpack_public_path__ + "img/31.96052e91.jpg";